import React, { FC, ReactNode, useState } from "react";
import classNames from "classnames";

import Icon from "../Icon";

type Props = {
  title: string;
  open?: boolean;
  children: ReactNode;
  className?: string;
  expandedClassName?: string;
  collapseClassName?: string;
  dataTest?: string;
};

export const CollapsePanel: FC<Props> = ({
  title,
  open = false,
  children,
  className,
  expandedClassName = "",
  collapseClassName = "",
  dataTest,
}) => {
  const [isOpen, setIsOpen] = useState(open);

  const handleClick = () => setIsOpen((current) => !current);

  return (
    <div
      className={classNames(className, {
        [expandedClassName]: isOpen,
        [collapseClassName]: !isOpen,
      })}
      data-test={dataTest}
    >
      <button
        data-test={`${dataTest}-btn`}
        className={classNames(
          "mb-4 flex flex-row justify-between items-center gap-3 w-full",
          {
            "text-purple-500": isOpen,
            "text-gray-500": !isOpen,
          }
        )}
        onClick={handleClick}
        type="button"
      >
        <h6 className="font-bold text-base text-left">{title}</h6>

        <div>
          <Icon
            icon={isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
            size={24}
          />
        </div>
      </button>

      {isOpen && (
        <div className="font-medium text-gray-300 text-base">{children}</div>
      )}
    </div>
  );
};
